const PlayerIntegration = require("../Player/PlayerIntegration")

const TURN_DISPLAY_ON_CALL_TYPE = 1;
const TURN_DISPLAY_OFF_CALL_TYPE = 2;
const SECONDS = 1000;
const MINIMUM_TIME_BETWEEN_CALLS = 10 * SECONDS;

let lastConfigurationCallTime = 0;
let lastConfigurationCallArgument = null;

let lastTurnCallTime = 0;
let lastTurnCallType = null;

const clean = () => {
  lastConfigurationCallTime = 0;
  lastConfigurationCallArgument = null;
  lastTurnCallTime = 0;
  lastTurnCallType = null;
}

const setDisplayControlConfiguration = configuration => {
  const allow = checkIfConfigurationCallIsAllowed( configuration );

  if( !allow ) {
    return Promise.resolve();
  }

  return PlayerIntegration.setDisplayControlConfiguration( configuration );
}

const turnDisplayOn = () => {
  const allow = checkIfTurnCallIsAllowed( TURN_DISPLAY_ON_CALL_TYPE );

  if( !allow ) {
    return Promise.resolve();
  }

  return PlayerIntegration.turnDisplayOn();
}

const turnDisplayOff = () => {
  const allow = checkIfTurnCallIsAllowed( TURN_DISPLAY_OFF_CALL_TYPE );

  if( !allow ) {
    return Promise.resolve();
  }

  return PlayerIntegration.turnDisplayOff();
}

const checkIfConfigurationCallIsAllowed = callArgument => {
  const now = Date.now();

  try {
    if( lastConfigurationCallArgument !== callArgument ) {
      return true;
    }

    const timeSinceLastCall = now - lastConfigurationCallTime;

    return timeSinceLastCall > MINIMUM_TIME_BETWEEN_CALLS;
  } finally {
    lastConfigurationCallTime = now;
    lastConfigurationCallArgument = callArgument;
  }
}

const checkIfTurnCallIsAllowed = callType => {
  const now = Date.now();

  try {
    if( lastTurnCallType !== callType ) {
      return true;
    }

    const timeSinceLastCall = now - lastTurnCallTime;

    return timeSinceLastCall > MINIMUM_TIME_BETWEEN_CALLS;
  } finally {
    lastTurnCallTime = now;
    lastTurnCallType = callType;
  }
}

module.exports = {
  setDisplayControlConfiguration,
  turnDisplayOn,
  turnDisplayOff,

  clean
}
